import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeBrands } from '../../requests/get_bike_brands_request';
import { getBikeModels } from '../../requests/get_bike_models_request';

function* getBikeCatalogsFromExperian({ params }) {
    yield put({
        type: 'SET_LEAD_CREATE_DATA',
        payload: {
            bikeInfoIsLoading: true,
        },
    });

    const payload = {
        bikeInfoIsLoading: false,
    };

    if (params.brand_id) {
        const bikeBrands = yield call(getBikeBrands, { _id: params.brand_id });

        if (bikeBrands.result) {
            payload.brands = {
                filters: { searchText: '' },
                data: bikeBrands.options,
            };

            if (params.model_id) {
                const bikeModels = yield call(getBikeModels, { _id: params.model_id });

                if (bikeModels.result) {
                    payload.models = {
                        filters: { searchText: '' },
                        data: bikeModels.options,
                    };
                }
            }
        }
    }

    yield put({ type: 'SET_LEAD_CREATE_DATA', payload });
}

export default function* getBikeCatalogsFromExperianSaga() {
    yield takeEvery('GET_LEAD_CREATE_BIKE_EXPERIAN_CATALOG', getBikeCatalogsFromExperian);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/getBikeCatalogsFromExperian.saga.js